<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.role.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.role.add')}}</el-button>
                    <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.role.delete')}}</el-button>
                </div>
                <div class="handle-headright">
                    <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.role.codePh')"></el-input>
                    <el-input v-model="query.Field2" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.role.namePh')"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.role.search')}}</el-button>
                </div>
            </div>
            <el-table :data="roles" border class="table" ref="multipleTable" :element-loading-text="$t('pages.role.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="handleEdit">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.role.index')"></el-table-column>
                <el-table-column prop="name" :label="$t('pages.role.name')"></el-table-column>
                <el-table-column prop="description" :label="$t('pages.role.description')" width="300"></el-table-column>
                <el-table-column :label="$t('pages.role.enabled')">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enabledFt" @change="changeUse(scope.row)" />
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="enabled" label="是否使用">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.enabled === '1' ? 'primary' : 'danger'" disable-transitions>{{
                            scope.row.enabled | usertypeFormat
                        }}</el-tag>
                    </template>
                </el-table-column>-->
                <!-- <el-table-column prop="modifyUserId" label="操作人"></el-table-column> -->
                <el-table-column sortable prop="modifyDate" :label="$t('pages.role.operateTime')" width="140">
                    <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
                </el-table-column>
                <el-table-column :label="$t('pages.role.actions.edit')" width="180" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" icon="el-icon-tickets" @click="handleShow(scope.row.id, scope.row)">查看 </el-button> -->
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">{{$t('pages.role.actions.edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="headTitle" :visible.sync="editVisible" width="40%" :close-on-click-modal="false" @close="clsOpt">
            <el-form ref="role" :model="role" :rules="rules" label-width="90px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.role.fields.name')" prop="name">
                            <el-input v-model="role.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.role.fields.enabled')" prop="enabled">
                            <el-switch v-model="role.enabled"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item :label="$t('pages.role.fields.description')" prop="description">
                            <el-input type="textarea" v-model="role.description" class="size-full"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">{{$t('pages.role.dialog.cancel')}}</el-button>
                <el-button type="primary" @click="saveEdit('role')">{{$t('pages.role.dialog.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { dateFormat, SortField, toTree } from '../../utils/helper';

export default {
    name: 'role',
    data: function () {
        const checkPass = (rule, value, callback) => {
            if (value !== this.role.Password) {
                callback(new Error('两次输入密码不一致！'));
            } else {
                callback();
            }
        };
        return {
            headTitle: '',
            isadd: false,
            role: {},
            editVisible: false,
            roles: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            rolearr: [],
            query: {
                Field1: '',
                Field2: '',
                PageIndex: 1,
                PageSize: 15
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: this.$t('pages.role.rules.nameRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 15,
                        message: this.$t('pages.role.rules.lengthRange'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm');
        },
        usertypeFormat(UserType) {
            var usertypeName = '';
            if (UserType == '1') {
                usertypeName = '启用';
            } else {
                usertypeName = '停用';
            }
            return usertypeName;
        }
    },
    created() {
        this.getData();
    },

    methods: {
        saveEdit() {
            this.$refs['role'].validate((valid) => {
                if (valid) {
                    this.role.enabled = this.role.enabled ? '1' : '0';
                    console.log(this.role);

                    if (this.isadd) {
                        this.$zybhttp
                            .post('Role/RoleAdd', this.role)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.role.notify.addSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                    this.role = {};
                                } else {
                                    this.$notify.error(this.$t('pages.role.notify.addFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.role.notify.networkAddError')));
                    } else {
                        this.$zybhttp
                            .post('Role/RoleUpdate', this.role)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.role.notify.updateSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(this.$t('pages.role.notify.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.role.notify.networkUpdateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        changeUse(row) {
            row.enabled = row.enabledFt ? '1' : '0';
            //this.$notify.error(JSON.stringify(row));
            this.$zybhttp
                .post('Role/RoleUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('pages.role.notify.updateSuccess'));
                        this.getData();
                    } else {
                        this.$notify.error(this.$t('pages.role.notify.updateFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.role.notify.networkUpdateError')));
        },
        getData() {
            // this.loading=true;
            this.$zybhttp
                .post('role/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.enabledFt = x.enabled == '1';
                            return x;
                        }, []);
                        this.roles = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.role.notify.networkListError')));
        },
        getroleArr: function () {
            this.$zybhttp
                .post('role/GetList', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        d = d.sort(SortField('id', 'asc'));
                        var arr = [{ id: 0, pid: 9999, value: 0, label: this.$t('pages.role.companyRoot') }];
                        for (var i = 0; i < d.length; i++) {
                            arr.push({ id: d[i].id, pid: d[i].parentId, value: d[i].id, label: d[i].name });
                        }
                        this.rolearr = toTree(arr);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.role.notify.networkListError')));
        },
        handleEdit(row) {
            this.getroleArr();
            this.role = JSON.parse(JSON.stringify(row));
            this.editVisible = true;
            this.role.enabled = this.role.enabled == '1';
            this.isadd = false;
            this.headTitle = this.$t('pages.role.dialog.editTitleUpdate');
        },
        handleAdd() {
            this.getroleArr();
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.role = {};
            this.isadd = true;
            let date = new Date();
            // this.role.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.role.createUserId = userinfo.loginId;
            this.role.modifyUserId = userinfo.loginId;
            //this.role.isUse =true;
            this.editVisible = true;
            this.headTitle = this.$t('pages.role.dialog.editTitleAdd');
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.role.notify.deleteSelectedWarning'));
                return;
            }
            this.$confirm(this.$t('pages.role.notify.deleteConfirm'), this.$t('pages.role.notify.deleteConfirmTitle'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('Role/RoleDel?ids=1')
                        .get('Role/RoleDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.role.notify.deleteSuccess', { names: str }));
                                this.getData();
                            } else {
                                this.$notify.error(this.$t('pages.role.notify.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.role.notify.networkDeleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        },
        clsOpt() {
            this.role.enabled = this.role.enabled ? '1' : '0';
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>

<style>
/* 富文本框高度设置 */
.ql-container {
    min-height: 200px;
    height: 200px;
}
</style>
